<template>
    <div class="context-menu--container"
         v-show="active"
         :style="style"
         tabindex="-1"
         @click="onClick"
         @contextmenu.capture.prevent>
        <slot :data="data"></slot>
    </div>
</template>

<script>
    export default {
        name:     "ContextMenuComponent",
        data() {
            return {
                active: false,
                top:    null,
                left:   null,
                data:   null
            }
        },
        props:    {
            /**
             * Close the menu on click.
             *
             * @type {boolean}
             */
            closeOnClick:  {
                type:    Boolean,
                default: true
            },
            /**
             * Close the menu automatically on window scroll.
             *
             * @type {boolean}
             */
            closeOnScroll: {
                type:    Boolean,
                default: true
            }
        },
        computed: {
            /**
             * Generate the CSS styles for positioning the context menu.
             *
             * @returns {object|null}
             */
            style() {
                const self = this;

                return self.active
                    ? {top: `${self.top}px`, left: `${self.left}px`}
                    : null;
            },
        },
        mounted() {
            const self = this;

            if (self.closeOnScroll) {
                self.addScrollEventListener();
            }

            self.addClickOutsideEventListener();
        },
        beforeUnmount() {
            const self = this;

            if (self.closeOnScroll) {
                self.removeScrollEventListener();
            }

            self.removeClickOutsideEventListener();
        },
        methods:  {
            /**
             * Add scroll event listener to close context menu.
             */
            addScrollEventListener() {
                const self = this;

                window.addEventListener('scroll', self.close);
            },
            /**
             * Add click event listener to close context menu.
             */
            addClickOutsideEventListener() {
                const self = this;

                window.addEventListener('click', self.onClickOutside);
            },
            /**
             * Close the context menu.
             */
            close() {
                const self = this;

                self.top    = null;
                self.left   = null;
                self.data   = null;
                self.active = false;

                self.$emit('close', true);
            },
            /**
             * Close the menu if `closeOnClick` is set to true.
             */
            onClick() {
                const self = this;

                if (self.closeOnClick) {
                    self.close();
                }
            },
            /**
             * Close the menu if blur event triggered outside.
             */
            onClickOutside(event) {
                const self = this;

                if (event.button === 2) {
                    return true;
                }

                if (!jQuery(event.target).closest('.context-menu--container').length) {
                    self.close();
                }
            },
            /**
             * Open the context menu.
             *
             * @param {MouseEvent} event
             * @param {array|object|string} data User provided data for the menu
             */
            open(event, data) {
                const self = this;

                self.data   = data;
                self.active = true;

                self.$nextTick(() => {
                    self.positionMenu(event.clientY, event.clientX);
                    self.$el.focus();
                });
            },
            /**
             * Set the context menu top and left positions.
             *
             * @param {number} top
             * @param {number} left
             */
            positionMenu(top, left) {
                const self = this;

                const largestHeight = window.innerHeight - self.$el.offsetHeight - 25;
                const largestWidth  = window.innerWidth - self.$el.offsetWidth - 25;

                if (top > largestHeight) {
                    top = largestHeight;
                }

                if (left > largestWidth) {
                    left = largestWidth;
                }

                self.top  = top;
                self.left = left;
            },
            /**
             * Remove the scroll event listener to close the context menu.
             */
            removeScrollEventListener() {
                const self = this;

                window.removeEventListener('scroll', self.close);
            },
            /**
             * Remove the click event listener to close the context menu.
             */
            removeClickOutsideEventListener() {
                const self = this;

                window.removeEventListener('click', self.clickOutside);
            }
        },
        watch:    {
            /**
             * Add or remove the scroll event listener when the prop value changes.
             *
             * @param {boolean} value
             * @param {boolean} oldValue
             */
            closeOnScroll(value, oldValue) {
                const self = this;

                if (value === oldValue) {
                    return;
                }

                if (value) {
                    self.addScrollEventListener();
                } else {
                    self.removeScrollEventListener();
                }
            }
        }
    }
</script>